import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions } from '../../../actions/terytActions';
import FormTextField from '../../form/FormTextField';
import FormAutocompleteField from '../../form/FormAutocompleteField';
import { Field } from 'react-final-form';

const required = value => value ? undefined : 'Pole jest wymagane';

class TerytAddress extends React.Component {
  componentDidMount() {
    this.props.actions.loadLocalities(this.props.filter);
  }

  render() {
    const { voterRequiredData, localities, streets, change, addressRestrictedToCities } = this.props;
    return (
      <React.Fragment>
        <div>
          <Field
            name="respondent.teryt.localityCode"
            component={FormAutocompleteField}
            label="Miejscowość"
            placeholder="Miejscowość"
            validate={voterRequiredData.addressOptional ? undefined : required}
            autocompleteData={localities.filter(l => !addressRestrictedToCities.length || addressRestrictedToCities.includes(l.name))
              .map(l => ({ id: l.code, name: `${l.name} (${l.auxiliaryName})` }))}
            onChange={(_, value) => {
              change('respondent.teryt.streetCode', null);
              change('respondent.address', null);
              if (value) {
                const selectedLocality = localities.find(l => l.code === value);
                change('respondent.city', `${selectedLocality.name} (${selectedLocality.auxiliaryName})`);
                this.props.actions.loadStreets(value);
              } else {
                change('respondent.city', null);
              }
            }}
          />
        </div>
        <div>
          <Field
            name="respondent.teryt.streetCode"
            component={FormAutocompleteField}
            label="Adres zamieszkania"
            placeholder="Adres zamieszkania"
            //validate={voterRequiredData.addressOptional || streets.length === 0 ? undefined : required}
            validate={required}
            autocompleteData={streets.map(s => ({ id: s.code, name: s.displayName }))}
            onChange={(_, value) => {
              if (value) {
                if (value === 'brak') {
                  //change('respondent.teryt.streetCode', null);
                  const selectedStreet = streets.find(s => s.code === value);
                  change('respondent.address', selectedStreet.displayName);
                } else {
                  const selectedStreet = streets.find(s => s.code === value);
                  change('respondent.address', selectedStreet.displayName);
                }
              } else {
                change('respondent.address', null);
              }
            }}
          />
          <Field
            name="respondent.number"
            component={FormTextField}
            label="Numer domu"
            validate={voterRequiredData.addressOptional ? undefined : required}
            style={{ marginRight: 10, width: 110 }}
          />
          <Field
            name="respondent.localNumber"
            component={FormTextField}
            label="Numer lokalu"
            style={{ width: 110 }}
          />
        </div>
      </React.Fragment>);
  }
}

TerytAddress.propTypes = {
  actions: PropTypes.object.isRequired,
  voterRequiredData: PropTypes.object.isRequired,
  localities: PropTypes.array.isRequired,
  streets: PropTypes.array.isRequired,
  change: PropTypes.func.isRequired,
  filter: PropTypes.string,
  addressRestrictedToCities: PropTypes.array.isRequired,
};

function mapStateToProps(state) {
  return {
    localities: state.teryt.localities,
    streets: [...state.teryt.streets, { code: 'brak', displayName: 'Brak nazwy ulicy' }],
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(TerytAddress);



// WEBPACK FOOTER //
// ./src/components/consultationSurveys/responderVerification/TerytAddress.js